import { FC } from "react";

import StepNavigationStep from "components/StepNavigation/composition/StepNavigationStep";
import Button from "components/Inputs/Button";
import { Trans, useTranslation } from "react-i18next";
import { searchMarketAction } from "pages/Home/core/home.helpers";

import {
  MyliPlatformId,
  IConfigurationState,
  IAPIObjective,
} from "redux/configuration/configuration.interface";
import { useSelector } from "react-redux";

import { IModalChild } from "utils/types/modalChild";
import { useMarketActionCTA } from "utils/hooks/useMarketActionCTA/useMarketActionCTA";

interface IProps extends IModalChild {}

const ModalConfigStepFacebook: FC<IProps> = ({ hideModal }) => {
  const { t } = useTranslation("modals", { keyPrefix: "facebook" });
  const { configuration } = useSelector((state: IConfigurationState) => state);

  const marketAction = searchMarketAction(
    MyliPlatformId.FACEBOOK,
    configuration?.w
  );

  const handleCTAClick = useMarketActionCTA(
    hideModal,
    marketAction?.u,
    IAPIObjective.FOLLOW_FACEBOOK
  );

  return (
    <StepNavigationStep className="modal__content" step={1}>
      <div className="modal__img">
        <img src="/static/images/modals/facebook.png" alt="facebook logo" />
      </div>
      <h2 className="modal__title">
        <Trans
          ns="modals"
          components={[<span className="c-facebook-title"></span>]}
          i18nKey="facebook.title"
        />
      </h2>
      <p>{t("subtitle")}</p>
      <Button
        text={t("CTA")}
        onClick={handleCTAClick}
        appearance="facebook"
        className="modal__btn"
      />
    </StepNavigationStep>
  );
};

export default ModalConfigStepFacebook;
